export const GET_PRODUCT = 'GET_PRODUCT'
export const SET_LOADING = 'SET_LOADING'
export const CLEAR_LOADING = 'CLEAR_LOADING'
export const SET_ERROR = 'SET_ERROR'
